<div class="r-header">
    <img src="assets/images/logo-dark.svg" alt="Logo" />
</div>

<div class="profile-screen">
    <div class="profile-card">
        <div class="back-btn">
            <a (click)="goBack()" style="cursor: pointer;">
                <i class="ph ph-arrow-left"></i>
                <span>{{ 'company.back' | translate }}</span>
            </a>
        </div>

        <!-- Upload Logo -->
        <div class="upload-file mb-4">
            <h3>{{ 'company.title' | translate }}</h3>
            <div class="upload-wrapper" (dragover)="onDragOver($event)" (dragleave)="onDragLeave()"
                (drop)="onDrop($event)" [ngStyle]="{ borderColor: borderColor }">
                <ng-container *ngIf="imagePreview['business_logo']; else uploadPlaceholder">
                    <div class="upload-img">
                        <img [src]="imagePreview['business_logo']" alt="Company Logo Preview" class="preview-image" />
                    </div>
                    <button type="button" class="btn-close " (click)="removeImage('business_logo')" aria-label="Close">
                        <i class="fa fa-close"></i>
                    </button>
                </ng-container>

                <ng-template #uploadPlaceholder>
                    <div (click)="triggerProfileFileInput()" class="upload-circle-outer">
                        <div class="upload-circle">
                            <i class="ph ph-image"></i>
                        </div>
                        <p class="upload-text">
                            <span>{{ 'company.upload-logo' | translate }}</span>, {{ 'company.drag-drop' | translate }}
                        </p>
                    </div>
                </ng-template>

                <input type="file" #profileFileInput  accept=".png, .jpg, .jpeg" hidden
                    (change)="onProfileFileSelected($event)" />
            </div>
            <small class="error text-danger mt-1 d-block"
                *ngIf="CompanyForm.controls['business_logo'].invalid && CompanyForm.controls['business_logo'].touched">
                <span *ngIf="CompanyForm.controls['business_logo'].errors?.['required']">
                    {{ 'company.field-required' | translate }}
                </span>
            </small>
        </div>

        <!-- Company Info Form -->
        <form [formGroup]="CompanyForm" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-lg-12">
                    <div class="mb-3">
                        <label class="form-label">{{ 'company.sector' | translate }}</label>
                        <nz-cascader [nzOptions]="sectorsTree" [nzPlaceHolder]="'company.select-sector' | translate"
                            class="form-control-qr category-cascader" formControlName="sector_id"
                            [nzShowSearch]="true" [nzChangeOnSelect]="true" [nzMultiple]="true"
                            nzExpandTrigger="hover">
                        </nz-cascader>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="mb-3 position-relative">
                        <label class="form-label">{{ 'company.business-name' | translate }} <span>*</span></label>
                        <input type="text" class="form-control" [placeholder]="'company.enter-company-name' | translate"
                            formControlName="name" />
                        <small class="error text-danger mt-1 d-block"
                            *ngIf="CompanyForm.controls['name'].invalid && CompanyForm.controls['name'].touched">
                            <span *ngIf="CompanyForm.controls['name'].errors?.['required']">
                                {{ 'company.field-required' | translate }}
                            </span>
                        </small>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="mb-3">
                        <label class="form-label">{{ 'company.about-business' | translate }}</label>
                        <textarea class="form-control" rows="6" [placeholder]="'company.enter-details' | translate"
                            formControlName="address"></textarea>
                    </div>
                </div>

                <div class="col-lg-12">
                    <button type="submit" class="btn btn-primary btn-lg w-100" [disabled]="isSubmitting">{{ 'company.save-btn' | translate }}</button>
                </div>
            </div>
        </form>
    </div>
</div>

<!-- Image Cropper Modal -->
<nz-modal [(nzVisible)]="cropperModalVisible" [nzTitle]="'company.crop-image' | translate" [nzWidth]="600" [nzFooter]="cropperFooter"
    (nzOnCancel)="cancelCrop()" nzCentered nzClassName="luqta-custom-modal cropper-modal">
    <ng-container *nzModalContent>
        <div style="max-height: 500px; overflow: auto;">
            <image-cropper [imageFile]="imageFile" [maintainAspectRatio]="true" [aspectRatio]="1"
                [resizeToWidth]="600" [roundCropper]="false" format="png" (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()"
                (loadImageFailed)="loadImageFailed()">
            </image-cropper>
        </div>
    </ng-container>
    <ng-template #cropperFooter>
        <button class="btn cropper-cancel-btn" (click)="cancelCrop()">{{ 'company.cancel' | translate }}</button>
        <button class="btn cropper-save-btn" (click)="confirmCrop()">{{ 'company.crop-save' | translate }}</button>
    </ng-template>
</nz-modal>